module.exports = __webpack_public_path__ + "static/media/red_button.c5c77812.png";